// import fs from 'fs';
// import os from 'os';
// import path from 'path';

// const tempDir = os.tmpdir();

// export const writeToFile = (content) => {
//     const pathDirectory = path.join(tempDir, 'colours.txt');

//     try {
//         fs.writeFileSync(pathDirectory, content);
//     } catch (error) {
//         throw error;
//     }
// }

const formatFileName = (fileName) => {
    return fileName.split(' ')
        .map(word => word.toLowerCase())
        .join('-');
}

export const writeToFile = ( content, fileName = 'colours') => {
    try {
        const blob = new Blob(content);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${formatFileName(fileName)}.txt`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error(error);
        throw error;
    }
};
